// Theses values come from ../public/config.js
// @ts-ignore
const env = { ...window.env };

const config = {
  APP_ENV: env.APP_ENV,
  AUTH0_DOMAIN: env.AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: env.AUTH0_CLIENT_ID,
  AUTH0_CONNECTION: env.AUTH0_CONNECTION,
  AUTH0_LOGIN_AUDIENCE: env.AUTH0_LOGIN_AUDIENCE,
  AUTH0_CONSOMMATEUR_AUDIENCE: env.AUTH0_CONSOMMATEUR_AUDIENCE,
  FLS_API_DOMAIN: env.FLS_API_DOMAIN,
  FUAS_API_DOMAIN: env.FUAS_API_DOMAIN,
  CARD_STARTING_VALUE: env.CARD_STARTING_VALUE,
  REGISTER_CONFIRMATION_REDIRECT: env.REGISTER_CONFIRMATION_REDIRECT,
  COMMERCE_URL: env.COMMERCE_URL,
  ADDRESSES_REDIRECT: env.ADDRESSES_REDIRECT,
  AVANTAGES_FAMILIPLUS_FR_URL: env.AVANTAGES_FAMILIPLUS_FR_URL,
  AVANTAGES_FAMILIPLUS_EN_URL: env.AVANTAGES_FAMILIPLUS_EN_URL,
  GTM_ID: env.GTM_ID,
  RECAPTCHA_SITE_KEY: env.RECAPTCHA_SITE_KEY,
};

export default config;
